import { useAtom } from 'jotai';
import { type atomWithReset } from 'jotai/utils';

// A hook to manage an optimistic state using a Jotai atom
export function useOptimisticAtomState<T>(
  optimisticAtom: ReturnType<typeof atomWithReset<T | undefined>>,
  serverValue: T | undefined,
) {
  const [optimisticValue, setOptimisticValue] = useAtom(optimisticAtom);

  // Final value = optimistic override first, otherwise server state
  const value = optimisticValue ?? serverValue ?? undefined;

  return [value, setOptimisticValue] as const;
}
